// src/views-new/dashboard/components/DashboardInfoBox.tsx

import React from "react";
import { useTranslation } from "react-i18next";

export const DashboardInfoBox = () => {
  const { t } = useTranslation("common");
  const userHeadline = t("DASHBOARD.INFO_BOX.USER_HEADLINE");
  const body = t("DASHBOARD.INFO_BOX.BODY");
  const displayBody = body.length > 2000 ? body.slice(0, 2000) + "…" : body;

  return (
    <div
      style={{
        background: "#fff",
        border: "2px solid #e0e4ea",
        borderRadius: 10,
        boxShadow: "0 2px 8px rgba(10,37,64,0.08)",
        // Remove minHeight and height here
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        height: "24vh",
        margin: "16px 16px 0 16px",
      }}>
      {/* Content with vertical scroll */}
      <div
        style={{
          flex: 1,
          padding: "16px 24px",
          border: "1px solid #e0e4ea",
          borderRadius: 8,
          background: "#fff",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          overflowY: "auto",
        }}>
        <div style={{ fontWeight: 700, fontSize: 20, color: "#0A2540", marginBottom: 16 }}>
          {t("DASHBOARD.INFO_BOX.HEADING")}
        </div>
        <div
          style={{
            fontSize: 15,
            color: "#1a1a1a",
            lineHeight: 1.5,
            marginBottom: 16,
            whiteSpace: "pre-line",
            wordBreak: "break-word",
          }}>
          <p style={{ fontSize: 15, fontWeight: 500, color: "#0A2540" }}>{userHeadline}</p>
          <p style={{ fontSize: 14, color: "#0A2540" }}>{displayBody}</p>
        </div>
      </div>
    </div>
  );
};
